import { h, JSX, ComponentChildren } from 'preact'
import { IconType, Icon } from '../Icons/Icons'

import styles from './Tabs.module.css'

interface TabHeadingProps extends JSX.HTMLAttributes {
  children: ComponentChildren | ((activeIndex: number) => ComponentChildren)
  icon?: IconType
}

export function TabHeading(props: TabHeadingProps) {
  const { children, icon, class: classStr, className, ...rest } = props

  return (
    <button
      class={[styles.tabHeading, icon && styles.tabHeadingIcon, classStr, className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {icon ? <Icon type={icon} /> : null}
      {children}
    </button>
  )
}
